// src/components/FaunaRace/FaunaVictoryModal.js
import React from 'react';
import styles from './FaunaRace.module.css';
import { ACTIONS } from './FaunaRaceGame';

function FaunaVictoryModal({ winner, dispatch }) {
    let trophy = '🤝';
    let text = 'PERMAINAN SERI!';
    if (winner !== 'tie') {
        trophy = winner === 'green' ? '🥥' : '🥭';
        text = `SELAMAT! TIM ${winner === 'green' ? 'KELAPA' : 'MANGGA'} MENANG!`;
    }

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.victoryContent}>
                <div className={styles.trophy}>{trophy}</div>
                <div className={styles.victoryText}>{text}</div>
                <button className={styles.woodButton} onClick={() => dispatch({ type: ACTIONS.PLAY_AGAIN })}>
                    MAIN LAGI
                </button>
                <button className={styles.woodButton} onClick={() => dispatch({ type: ACTIONS.GO_TO_SCREEN, payload: { screen: 'home' } })}>
                    KEMBALI KE MENU
                </button>
            </div>
        </div>
    );
}

export default FaunaVictoryModal;